import { C, STROKE, Figure, Label, ThermostatValve, WaterGradient, arrow } from './figureStyle';

const ID = 'fig-kold-bund';

export default function KoldIBundenFigure() {
  return (
    <Figure
      id={ID}
      height={250}
      title="Radiator set forfra, hvor farven går fra varm i toppen ved termostatventilen til kølig i bunden ved returen, med en pil der viser, at vandet afkøles på vej ned."
      caption="Varmt vand løber ind i toppen og afgiver varme på vej ned, så radiatoren er varm i toppen og kølig i bunden."
      defs={
        <>
          <linearGradient id={`${ID}-fill`} gradientUnits="userSpaceOnUse" x1="0" y1="60" x2="0" y2="220">
            <stop offset="0" stopColor={C.rust} stopOpacity="0.5" />
            <stop offset="0.5" stopColor={C.light} />
            <stop offset="1" stopColor={C.line} />
          </linearGradient>
          <WaterGradient id={`${ID}-water`} y1={74} y2={204} />
        </>
      }
    >
      {/* Radiator med farveovergang fra varm top til kølig bund */}
      <rect x="60" y="60" width="160" height="160" rx="6" fill={`url(#${ID}-fill)`} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Fremløb og termostatventil i toppen */}
      <line x1="4" y1="72" x2="18" y2="72" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <line x1="46" y1="72" x2="60" y2="72" stroke={C.rust} strokeWidth={STROKE.outline} />
      <ThermostatValve cx={33} pipeY={72} />

      {/* Retur i bunden */}
      <line x1="60" y1="204" x2="6" y2="204" stroke={C.grey} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'cold')} />

      {/* Vandet afkøles på vej ned */}
      <line x1="240" y1="74" x2="240" y2="204" stroke={`url(#${ID}-water)`} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'cold')} />

      {/* Labels */}
      <Label x={4} y={18} lines={['Termostatventil']} />
      <Label x={4} y={102} lines={['Fremløb']} />
      <Label x={4} y={232} lines={['Retur']} />
      <Label x={140} y={96} anchor="middle" lines={['Varm i toppen']} />
      <Label x={140} y={196} anchor="middle" lines={['Kølig i bunden']} />
      <Label x={252} y={134} kind="note" lines={['Vandet afkøles', 'på vej ned']} />
    </Figure>
  );
}
